import React from 'react';
import NewBlogCardShortVersion from '@/components/reusable/NewBlogCardShortVersion/NewBlogCardShortVersion';
import { PageContainer } from '@/components/containers/PageContainer/PageContainer';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Label from '@/components/form/Label/Label';
import './BlogModule.scss';

const BlogsDataRow = props => {
  const { blogsData, goToBlogPreDetail, onBlogUpdate } = props;
  const chunkArray = (array, size) => {
    const chunks = [];
    for (let i = 0; i < array.length; i += size) {
      chunks.push(array.slice(i, i + size));
    }
    return chunks;
  };
  const groupedSpaces = chunkArray(blogsData || [], 4);
  const containerClass = 'm-flex-column gap-20 format100 margb20';
  return (
    <>
      {groupedSpaces.map((group, groupIndex) => (
        <FlexContainer
          key={groupIndex}
          className={containerClass}
          justifyBetween
        >
          {group.map((blog, index) => (
            <NewBlogCardShortVersion
              key={index}
              blogInfo={blog}
              handleDetailButton={() => goToBlogPreDetail(blog)}
              onUpdate={onBlogUpdate}
            />
          ))}
          {groupIndex === groupedSpaces.length - 1 &&
            group.length < 4 &&
            Array.from({ length: 4 - group.length }).map((_, emptyIndex) => (
              <FlexContainer
                className={'padtb20 flex-column justify-between format100'}
                key={emptyIndex}
              ></FlexContainer>
            ))}
        </FlexContainer>
      ))}
    </>
  );
};

const BlogModule = props => {
  const {
    customTitle,
    buttonTitle,
    isShowButton,
    blogsData,
    extraClass,
    buttonMethod,
    onBlogUpdate,
    homeMode,
  } = props;
  const navigate = useNavigate();

  const lenguage = useSelector(state => state.lenguage?.lang);

  const goToBlogPreDetail = blogsData => {
    const urlTitle = encodeURIComponent(blogsData?.post_id);
    const path =
      lenguage === 'ES'
        ? `/blog-popnest-detalle/${urlTitle}`
        : `/blog-popnest-detail/${urlTitle}`;

    navigate(path);
  };

  return (
    <PageContainer mainContainerClass="flex-column padlr130 padtb10 m-padtb10 m-padlr10">
      <FlexContainer
        className={'flex-column myBlogsModule  format100 ' + extraClass}
        justifyBetween
        alignItemsStart
      >
        {customTitle && (
          <>
            {homeMode && (
              <Label type="bold m-margb40 m-marglr0 m-margt10 m-text-22 margb60 marglr0 margt80 m-margt20 text-22 text-center width100">
                <strong>{customTitle}</strong>
              </Label>
            )}
            {!homeMode && (
              <Label type="text-32 m-text-24 marglr0 m-marglr0 margt20 m-margt10 margb60 m-margb40">
                <strong>{customTitle}</strong>
              </Label>
            )}
          </>
        )}
        <BlogsDataRow
          blogsData={blogsData}
          goToBlogPreDetail={goToBlogPreDetail}
          onBlogUpdate={onBlogUpdate}
        />
        {isShowButton && (
          <FlexContainer className={'flex-column width100'} alignItemsCenter>
            <button
              onClick={() => buttonMethod()}
              className={
                'pointer border-rad8px margtb10 grayShadow16 padlr40 padtb10 text-14 borderGray5'
              }
            >
              {buttonTitle}
            </button>
          </FlexContainer>
        )}
      </FlexContainer>
    </PageContainer>
  );
};

export default BlogModule;
